import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.header');
import { OnInit, Input, DoCheck } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { Router } from '@angular/router';

@Component({
    selector: 'wiz-component-header',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.header/view.scss */
/* src/app/component.header/view.scss: no such file or directory */`],
})
export class ComponentHeaderComponent implements OnInit, DoCheck {

    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) { }

    public currentUrl: any;
    public first = "";
    public second = "";
    public third = "";
    public forth = "";
    public menu: any;
    public currentMenu: any;

    public userMenu = [
        { label: "대시보드", path: "dashboard", isLink: true },
        { label: "공지사항", path: "notice", isLink: true },
        { label: "기술지원", path: "support", isLink: true },
        { label: "성과", path: "research", isLink: true },
        { label: "게시판", path: "board", isLink: true },
        { label: "스토리지", path: "storage", isLink: true },
        { label: "연구그룹", path: "group", isLink: true },
        { label: "마이페이지", path: "mypage", isLink: true }
    ];
    public groupMenu = [
        { label: "정보", path: "info", isLink: true },
        { label: "연구그룹 연구자", path: "user", isLink: true }
    ];
    public communityMenu = [
        { label: "정보", path: "info", isLink: true },
        { label: "연구 그룹", path: "group", isLink: true },
        { label: "연구커뮤니티 연구자", path: "user", isLink: true }
    ];
    public adminMenu = [
        { label: "사용자 관리", path: "users", isLink: true },
        { label: "승인 요청 관리", path: "request", isLink: true },
        { label: "커뮤니티 관리", path: "community", isLink: true },
        { label: "티켓팅 관리", path: "ticketing", isLink: true },
        { label: "FAQ 관리", path: "faq", isLink: true },
        { label: "매뉴얼 관리", path: "manual", isLink: true },
        { label: "성과 관리", path: "research", isLink: true },
        { label: "공지사항 관리", path: "notice", isLink: true },
        { label: "게시판 관리", path: "board", isLink: true },
        { label: "스토리지 관리", path: "storage", isLink: true },
        { label: "매뉴얼 이미지 관리", path: "image", isLink: true },
        { label: "비밀번호 변경", path: "password", isLink: true },
    ];

    public async ngOnInit() {
        await this.service.init();
        await this.service.render();
    }

    public async ngDoCheck() {
        const url = this.router.url;
        if (this.currentUrl !== url) {
            this.currentUrl = url;
            this.second = this.third = '';
            let segment = url.split('/').filter(Boolean);

            if (url.includes("admin")) {
                this.menu = this.adminMenu;
                segment = segment.slice(1);
            } else {
                this.menu = this.userMenu;
            }
            // console.log("menu : ", this.menu)
            this.first = this.menu.find(item => url.includes(item.path)).label || '';

            // if (segment.length > 1) {
            //     if (["커뮤니티 관리"].includes(this.first)) this.second = this.communityMenu.find(item => url.includes(item.path)).label || '';
            //     else if (["연구 그룹"].includes(this.first)) this.second = this.groupMenu.find(item => url.includes(item.path)).label || '';

            //     if (segment.length > 2) {
            //         const exclude = ['info', 'issue', 'document', 'alert', 'use', 'memo'];
            //         if ((["기관현황", "기관 관리"].includes(this.first) && !exclude.includes(segment[-2])) || (["공지사항", "공지사항 관리"].includes(this.first) && !exclude.includes(segment[-1]))) {
            //             this.third = "상세보기";
            //         }
            //     }
            // }
            if (segment.length > 1) {
                // reset
                this.second = '';
                this.third = '';

                // 유틸
                const has = (...keys: string[]) => keys.some(k => segment.includes(k));
                const isCreate = () => has('create', 'new', 'write');
                const isDetail = () => has('detail', 'view', 'id', 'show');

                // ===== 사용자 메뉴 =====
                if (this.first === '기술지원') {
                    if (has('manual')) {
                        this.second = '매뉴얼';
                    } else if (has('ticketing')) {
                        this.second = '티켓팅';

                        const idx = segment.indexOf('ticketing');
                        const tail = segment[idx + 1]; // ticketing 뒤에 오는 값(없으면 목록)

                        if (!tail) {
                            this.third = '';
                        } else if (['new', 'create', 'write'].includes(tail)) {
                            this.third = '작성';
                        } else {
                            this.third = '상세보기';
                        }

                    } else if (has('faq')) {
                        this.second = 'FAQ';

                        const idx = segment.indexOf('faq');
                        const tail = segment[idx + 1]; // faq 뒤(없으면 목록)

                        if (!tail) {
                            this.third = '';
                        } else if (['new', 'create', 'write'].includes(tail)) {
                            this.third = '작성';
                        } else {
                            this.third = '상세보기';
                        }
                    }
                } else if (this.first === '성과') {
                    if (isCreate()) this.second = '작성';
                    else this.second = '상세보기';
                } else if (this.first === '연구 그룹') {
                    if (has('group', 'groups', 'list')) this.second = '그룹 목록';
                    else if (has('request', 'requests')) this.second = '요청 목록';
                } else if (this.first === '공지사항') {
                    this.second = '상세보기';
                } else if (this.first === '게시판') {
                    if (isCreate()) this.second = '작성';
                    else this.second = '상세보기';
                }

                // ===== 관리자 메뉴 =====
                // else if (this.first === '커뮤니티 관리') {
                //     this.second = '커뮤니티';
                //     // 2뎁스 커뮤니티가 확정된 뒤 3뎁스 결정
                //     if (has('group')) {
                //         // 연구 그룹 섹션
                //         if (has('info')) this.third = '연구 그룹 > 정보';
                //         else if (has('user', 'users', 'researcher', 'researchers')) this.third = '연구 그룹 > 연구자';
                //         else if (isCreate()) this.third = '연구 그룹 > 신규 생성';
                //         else this.third = '연구 그룹';
                //     } else if (has('info')) {
                //         this.third = '정보';
                //     } else if (has('user', 'users', 'researcher', 'researchers')) {
                //         this.third = '연구자';
                //     } else if (isCreate()) {
                //         this.third = '신규 생성';
                //     }
                else if (this.first === '커뮤니티 관리') {
                    // 초기화
                    this.second = '';
                    this.third = '';
                    this.forth = '';

                    const segments = this.currentUrl.split('/').filter(Boolean);
                    // ['admin','community','5','17','info']
                    const idx = segments.indexOf('community');
                    const after = segments.slice(idx + 1);
                    // ['5','17','info'] 또는 ['5','group']

                    const cid = after[0];          // communityID
                    const maybeGroupId = after[1]; // 숫자면 groupID
                    const isGroupContext = !isNaN(Number(maybeGroupId));

                    // ==========================
                    // ① 공통: 2단계 (커뮤니티)
                    // ==========================
                    this.second = '커뮤니티';

                    if (isGroupContext) {
                        // ==========================
                        // ② 그룹 내부 페이지
                        // URL: /community/:cid/:gid/:mode
                        // ==========================
                        this.third = '연구그룹';

                        const mode = after[2] || 'info';

                        if (mode === 'info') {
                            this.forth = '정보';
                        } else if (mode === 'user') {
                            this.forth = '연구자';
                        } else if (mode === 'group') {
                            this.forth = '연구그룹';
                        } else {
                            this.forth = ''; // 기타
                        }
                    } else {
                        // ==========================
                        // ③ 커뮤니티 레벨 페이지
                        // URL: /community/:cid/:mode
                        // ==========================
                        const mode = after[1] || 'info';

                        if (mode === 'info') {
                            this.third = '정보';
                            this.forth = '';
                        } else if (mode === 'group') {
                            this.third = '연구그룹';
                            this.forth = '';
                        } else if (mode === 'user') {
                            this.third = '연구자';
                            this.forth = '';
                        }
                    }
                } else if (this.first === '티켓팅 관리') {
                    this.second = '상세보기';
                } else if (this.first === 'FAQ 관리') {
                    if (isCreate()) this.second = '작성';
                    else this.second = '상세보기';
                } else if (this.first === '공지사항 관리') {
                    if (isCreate()) this.second = '작성';
                    else this.second = '상세보기';
                } else if (this.first === '성과 관리') {
                    this.second = '상세보기';
                } else if (this.first === '사용자 관리') {
                    if (isCreate()) this.second = '신규 생성';
                } else if (this.first === '게시판 관리') {
                    this.second = '상세보기';
                }
            }
            await this.service.render();
        }
    }
}

export default ComponentHeaderComponent;